import classNames from 'classnames';
import { Spinner } from 'flowbite-react';
import {
    TransitionEvent,
    useCallback,
    useLayoutEffect,
    useRef,
    useState,
} from 'react';

export const useButtonSpinner = (loading = false) => {
    const spinnerWrapperRef = useRef<HTMLSpanElement>(null);

    const [shouldShowSpinner, setShouldShowSpinner] = useState(loading);

    useLayoutEffect(() => {
        if (loading && spinnerWrapperRef.current) {
            /*
             * Wait for initial `width: 0;` to be drawn in browser and then
             * change to target width in order to properly trigger transition.
             */
            window.getComputedStyle(spinnerWrapperRef.current).width;
            setShouldShowSpinner(true);
        }
    }, [loading]);

    const onTransitionEnd = useCallback(
        (event: TransitionEvent<HTMLSpanElement>) => {
            if (
                event.propertyName === 'width' &&
                event.target === event.currentTarget &&
                !loading
            ) {
                setShouldShowSpinner(false);
            }
        },
        [loading]
    );

    return loading || shouldShowSpinner ? (
        <span
            ref={spinnerWrapperRef}
            className={classNames(
                'h-4 inline-flex overflow-hidden relative self-center transition-[width]',
                loading && shouldShowSpinner ? 'w-4' : 'w-0'
            )}
            onTransitionEnd={onTransitionEnd}
        >
            <Spinner className="absolute" size="sm" />
        </span>
    ) : null;
};
